import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import { translate } from 'utils/translation';
import styled from 'styled-components';

const KeyboardDatePickerStyled = styled(KeyboardDatePicker)`
  .MuiOutlinedInput-input {
    padding: 10.5px 14px;
  }
`;

export const Datepicker = ({
  dataCy, label, onChange, onError, value, ...config
}) => (
  <MuiPickersUtilsProvider locale={frLocale} utils={DateFnsUtils}>
    <KeyboardDatePickerStyled
      autoOk
      cancelLabel={translate('button.cancel')}
      clearable
      clearLabel={translate('button.delete')}
      data-cy={dataCy}
      format="dd/MM/yyyy"
      InputAdornmentProps={{ position: 'start' }}
      inputVariant="outlined"
      invalidDateMessage={translate('errors.invalidDate')}
      KeyboardButtonProps={{
        'aria-label': translate(label)
      }}
      label={translate(label)}
      maxDateMessage={translate('warnings.date.maxDate')}
      minDateMessage={translate('warnings.date.minDate')}
      value={value}
      onChange={(date) => onChange && onChange(date)}
      onError={(error) => onError && onError(error)}
      {...config}
    />
  </MuiPickersUtilsProvider>
);

Datepicker.propTypes = {
  dataCy: PropTypes.string,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  error: PropTypes.bool,
  label: PropTypes.string,
  maxDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  minDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  name: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ])
};

Datepicker.defaultProps = {
  dataCy: '',
  disableFuture: false,
  disablePast: false,
  error: false,
  label: 'common.date',
  maxDate: new Date('2100-01-01'),
  minDate: new Date('1900-01-01'),
  name: '',
  onChange: null,
  onError: null,
  required: false,
  value: null
};

export const DateTimepicker = ({
  dataCy, label, onChange, ...config
}) => (
  <MuiPickersUtilsProvider locale={frLocale} utils={DateFnsUtils}>
    <KeyboardDateTimePicker
      autoOk
      cancelLabel={translate('button.cancel')}
      clearable
      clearLabel={translate('button.delete')}
      data-cy={dataCy}
      format="dd/MM/yyyy HH:mm"
      inputVariant="outlined"
      invalidDateMessage={translate('errors.invalidDate')}
      KeyboardButtonProps={{
        'aria-label': translate(label)
      }}
      label={translate(label)}
      maxDateMessage={translate('warnings.date.maxDate')}
      minDateMessage={translate('warnings.date.minDate')}
      onChange={(date) => onChange(date)}
      {...config}
    />
  </MuiPickersUtilsProvider>
);

DateTimepicker.propTypes = {
  ampm: PropTypes.bool,
  dataCy: PropTypes.string,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  error: PropTypes.bool,
  label: PropTypes.string,
  maxDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  minDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  name: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func
};

DateTimepicker.defaultProps = {
  ampm: false,
  dataCy: '',
  disableFuture: false,
  disablePast: false,
  error: false,
  label: 'common.date',
  maxDate: new Date('2100-01-01'),
  minDate: new Date('1900-01-01'),
  name: '',
  onChange: null,
  required: false
};